import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
// Functions
import { parseSecondsToMinutes } from "../../../../config/functions";
// Components
import {
  RoutineDiv,
  RoutineInfoDiv,
  TitleDiv,
  TitleText,
  CardDiv,
  InfoHideDiv,
  InfoText,
  InfoTextResponsive,
  InfoSpan,
  InfoShowDiv,
  InfoShowColumnDiv,
  InfoShowDayDiv,
  ShowRoutineButton,
  ArrowImg,
  RoutineExtraInfoDiv,
  ExtraInfoDayDiv,
  ExtraInfoTitle,
  ExtraInfoColumnsDiv,
} from "./styles";
// Assets
import IcoArrowUp from "../../../../assets/icons/ico_arrow_up_blue.svg";
import IcoArrowDown from "../../../../assets/icons/ico_arrow_down_blue.svg";

const RoutineInfo = ({ prescriptions }) => {
  const [isShowRoutine, setIsShowRoutine] = useState(false);
  const [protocolDay, setProtocolDay] = useState({
    MONDAY: 0,
    TUESDAY: 0,
    WEDNESDAY: 0,
    THURSDAY: 0,
    FRIDAY: 0,
    SATURDAY: 0,
    SUNDAY: 0,
  });
  const [protocolMinutes, setProtocolMinutes] = useState({
    MONDAY: 0,
    TUESDAY: 0,
    WEDNESDAY: 0,
    THURSDAY: 0,
    FRIDAY: 0,
    SATURDAY: 0,
    SUNDAY: 0,
  });
  const [todayProtocols, setTodayProtocols] = useState(0);
  const [todayMinutes, setTodayMinutes] = useState(0);
  const [weekProtocols, setWeekProtocols] = useState(0);
  const [weekMinutes, setWeekMinutes] = useState(0);
  const [t] = useTranslation("global");

  // Counting protocol days and time
  useEffect(() => {
    let protocolDay = {
      MONDAY: 0,
      TUESDAY: 0,
      WEDNESDAY: 0,
      THURSDAY: 0,
      FRIDAY: 0,
      SATURDAY: 0,
      SUNDAY: 0,
    };
    let protocolMinutes = {
      MONDAY: 0,
      TUESDAY: 0,
      WEDNESDAY: 0,
      THURSDAY: 0,
      FRIDAY: 0,
      SATURDAY: 0,
      SUNDAY: 0,
    };

    for (const prescription of prescriptions) {
      const dayOfWeek = prescription.WEEKDAY;
      if (protocolDay.hasOwnProperty(dayOfWeek)) {
        protocolDay[dayOfWeek]++;
        protocolMinutes[dayOfWeek] += parseSecondsToMinutes(prescription.SESSION_DURATION);
      }
    }

    setProtocolDay(protocolDay);
    setProtocolMinutes(protocolMinutes);

    const today = moment().format("dddd").toUpperCase();
    setTodayProtocols(protocolDay[today] || 0);
    setTodayMinutes(protocolMinutes[today] || 0);

    setWeekProtocols(prescriptions.length);
    setWeekMinutes(Object.values(protocolMinutes).reduce((totalDaysTime, currentDaytime) => totalDaysTime + currentDaytime, 0));
  }, [prescriptions]);

  const showWeeklyRoutine = (e) => {
    e.preventDefault();
    setIsShowRoutine(!isShowRoutine);
  };

  const parseMinutesToHours = (minutes) => {
    const roundedMinutes = Math.round(minutes);
    if (roundedMinutes > 59) {
      let h = parseInt(roundedMinutes / 60);
      let m = parseInt(roundedMinutes % 60);
      return `${h}h ${m} min`;
    }
    return `${roundedMinutes} min`;
  };

  const renderDesktopRoutineInfo = () => {
    return (
      <RoutineInfoDiv>
        <TitleDiv isHideShadow={isShowRoutine}>
          <TitleText>{t("prescriptions_routineText")}</TitleText>
        </TitleDiv>
        <CardDiv>
          {!isShowRoutine ? (
            <InfoHideDiv>
              <InfoText margin="0 0 0 30px">{t("prescriptions_routineTodayText")}</InfoText>
              <InfoText margin="0 30px">
                {t("activities")}: <InfoSpan>{todayProtocols}</InfoSpan>
              </InfoText>
              <InfoText>
                {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(todayMinutes)}</InfoSpan>
              </InfoText>
            </InfoHideDiv>
          ) : (
            <InfoShowDiv border={isShowRoutine}>
              <InfoShowColumnDiv width="160px">
                <InfoShowDayDiv padding="0 0 0 45px">
                  <InfoText fontWeight="bold">{t("prescriptions_routineWeekText")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px" background="#f2f2f2">
                  <InfoText>{t("prescriptions_routineDays_monday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px">
                  <InfoText>{t("prescriptions_routineDays_tuesday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px" background="#f2f2f2">
                  <InfoText>{t("prescriptions_routineDays_wednesday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px">
                  <InfoText>{t("prescriptions_routineDays_thursday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px" background="#f2f2f2">
                  <InfoText>{t("prescriptions_routineDays_friday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px">
                  <InfoText>{t("prescriptions_routineDays_saturday")}</InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv padding="0 0 0 45px" background="#f2f2f2">
                  <InfoText>{t("prescriptions_routineDays_sunday")}</InfoText>
                </InfoShowDayDiv>
              </InfoShowColumnDiv>
              <InfoShowColumnDiv width="130px">
                <InfoShowDayDiv>
                  <InfoText>
                    {t("activities")}: <InfoSpan>{weekProtocols}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.MONDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.TUESDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.WEDNESDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.THURSDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.FRIDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.SATURDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("activities")}: <InfoSpan>{protocolDay.SUNDAY}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
              </InfoShowColumnDiv>
              <InfoShowColumnDiv width="160px">
                <InfoShowDayDiv>
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(weekMinutes)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.MONDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.TUESDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.WEDNESDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.THURSDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.FRIDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv>
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.SATURDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
                <InfoShowDayDiv background="#f2f2f2">
                  <InfoText>
                    {t("prescriptions_routineTimeText")}: <InfoSpan>{parseMinutesToHours(protocolMinutes.SUNDAY)}</InfoSpan>
                  </InfoText>
                </InfoShowDayDiv>
              </InfoShowColumnDiv>
            </InfoShowDiv>
          )}
          <InfoTextResponsive fontWeight="600">{t("prescriptions_routineWeeklySummaryText")}</InfoTextResponsive>
          <ShowRoutineButton onClick={showWeeklyRoutine} border={isShowRoutine}>
            <ArrowImg src={isShowRoutine ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
          </ShowRoutineButton>
        </CardDiv>
      </RoutineInfoDiv>
    );
  };

  const renderResponsiveRoutineInfo = () => {
    return (
      <RoutineExtraInfoDiv>
        <ExtraInfoDayDiv padding="2px 0 2px 36%">
          <ExtraInfoTitle margin="0 35px 0 0">{t("activities")}</ExtraInfoTitle>
          <ExtraInfoTitle>{t("prescriptions_routineTimeText")}</ExtraInfoTitle>
        </ExtraInfoDayDiv>
        <ExtraInfoColumnsDiv>
          <InfoShowColumnDiv width="110px">
            <InfoShowDayDiv padding="0 0 0 10px">
              <InfoText fontWeight="bold">{t("prescriptions_routineWeekText")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px" background="#f2f2f2">
              <InfoText>{t("prescriptions_routineDays_monday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px">
              <InfoText>{t("prescriptions_routineDays_tuesday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px" background="#f2f2f2">
              <InfoText>{t("prescriptions_routineDays_wednesday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px">
              <InfoText>{t("prescriptions_routineDays_thursday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px" background="#f2f2f2">
              <InfoText>{t("prescriptions_routineDays_friday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px">
              <InfoText>{t("prescriptions_routineDays_saturday")}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv padding="0 0 0 10px" background="#f2f2f2">
              <InfoText>{t("prescriptions_routineDays_sunday")}</InfoText>
            </InfoShowDayDiv>
          </InfoShowColumnDiv>
          <InfoShowColumnDiv width="80px">
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{weekProtocols}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{protocolDay.MONDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{protocolDay.TUESDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{protocolDay.WEDNESDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{protocolDay.THURSDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{protocolDay.FRIDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{protocolDay.SATURDAY}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{protocolDay.SUNDAY}</InfoText>
            </InfoShowDayDiv>
          </InfoShowColumnDiv>
          <InfoShowColumnDiv width="100px">
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{parseMinutesToHours(weekMinutes)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{parseMinutesToHours(protocolMinutes.MONDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{parseMinutesToHours(protocolMinutes.TUESDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{parseMinutesToHours(protocolMinutes.WEDNESDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{parseMinutesToHours(protocolMinutes.THURSDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{parseMinutesToHours(protocolMinutes.FRIDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center">
              <InfoText>{parseMinutesToHours(protocolMinutes.SATURDAY)}</InfoText>
            </InfoShowDayDiv>
            <InfoShowDayDiv justifyContent="center" background="#f2f2f2">
              <InfoText>{parseMinutesToHours(protocolMinutes.SUNDAY)}</InfoText>
            </InfoShowDayDiv>
          </InfoShowColumnDiv>
        </ExtraInfoColumnsDiv>
      </RoutineExtraInfoDiv>
    );
  };

  return (
    <RoutineDiv>
      {renderDesktopRoutineInfo()}
      {isShowRoutine && renderResponsiveRoutineInfo()}
    </RoutineDiv>
  );
};

export default RoutineInfo;
